import React from "react";
import { Blog } from "../../../types/type";
import { Link } from "react-router-dom";
type Props = {
  blog: Blog;
};
const BlogCard: React.FC<Props> = ({ blog }) => {
  return (
    <Link className="cursor-pointer" to={`/blog/${blog._id}`}>
      <img
        className="object-cover rounded-lg rounded-r-none md:rounded-r-lg h-[195px] w-full"
        src={blog.thumbnail}
        alt=""
      />
      <div className="flex flex-col gap-1.5 pt-1.5">
        <h3 className="text-2xl font-bold">{blog.title}</h3>
        <p className="text-sm font-normal text-[#000000DE]">
          <time dateTime={new Date(blog.createdAt).toLocaleDateString()}>
            {new Date(blog.createdAt).toLocaleDateString()}
          </time>
        </p>
      </div>
    </Link>
  );
};

export default BlogCard;
